function hasErrors(fieldsError) {
  return fieldsError
    ? Object.keys(fieldsError).some(field => fieldsError[field])
    : false;
}

const progresses = {};

progresses.role = [
  {
    title: 'Должность',
    name: 'role',
    completed: false,
    fields: ['roleKey'], // Массив полей которые попадают в функцию check и getDescription
    check: (values, form) => {
      return !!(!hasErrors(form.getFieldsError(['roleKey'])) && values.roleKey);
    },
    getDescription: (values, props) => {
      // Функция для обработки полученных значений. values принимает значения из полей указаных в параметре fields, второй параметр данные которые передаются из пропсов компонента
      let val =
        props.roles &&
        props.roles.find(item => item.roleKey === values.roleKey);
      return val ? val.role : null;
    },
  },
];

progresses.phone = [
  {
    title: 'Номер телефона',
    name: 'phone',
    fields: ['phoneCode', 'phone'],
    completed: false,
    check: (values, form) => {
      return !!(
        !hasErrors(form.getFieldsError(['phoneCode', 'phone'])) &&
        values.phoneCode &&
        values.phone &&
        values.phone.length >= 10
      );
    },
    getDescription: values => {
      let val = `${values.phoneCode}${values.phone}`;
      return val;
    },
  },
];

progresses.default = [
  {
    title: 'ФИО',
    name: 'userName',
    completed: false,
    fields: ['lastname', 'name', 'patronymic'],
    check: (values, form) => {
      return !!(
        !hasErrors(form.getFieldsError(['lastname', 'name'])) &&
        values.lastname &&
        values.name
      );
    },
    getDescription: values => {
      let val = `${values.lastname} ${values.name[0].toUpperCase()}. `;
      val += values.patronymic ? `${values.patronymic[0].toUpperCase()}.` : '';
      return val;
    },
  },
  {
    title: 'E-mail',
    name: 'e-mail',
    fields: ['email'],
    completed: false,
    check: (values, form) => {
      return !!(!hasErrors(form.getFieldsError(['email'])) && values.email);
    },
    getDescription: values => {
      return values.email;
    },
  },
  /* TODO maybe next release (task_15081)} */
  // {
  //   title: 'Представитель',
  //   name: 'representative',
  //   fields: [
  //     'representativePhoneCode',
  //     'representativePhone',
  //     'representativeEmail',
  //     'representativeLastname',
  //     'representativeName',
  //     'representativePatronymic',
  //   ],
  //   completed: false,
  //   check: (values, form) => {
  //     return !hasErrors(
  //       form.getFieldsError([
  //         'representativePhoneCode',
  //         'representativePhone',
  //         'representativeEmail',
  //         'representativeLastname',
  //         'representativeName',
  //       ])
  //       ) &&
  //       values.representativeLastname &&
  //       values.representativeName &&
  //       values.representativeEmail &&
  //       values.representativePhone &&
  //       values.representativePhoneCode;
  //   },
  //   getDescription: values => {
  //     let val = [];
  //     if (values.representativeLastname && values.representativeName) {
  //       let username = `${
  //         values.representativeLastname
  //       } ${values.representativeName[0].toUpperCase()}. `;
  //       username += values.representativePatronymic
  //         ? `${values.representativePatronymic[0].toUpperCase()}.`
  //         : '';
  //       val.push(username);
  //     }
  //     if (values.representativePhoneCode && values.representativePhone) {
  //       val.push(
  //         `${values.representativePhoneCode}${values.representativePhone}`
  //       );
  //     }
  //     return val.length > 0 ? val.join(', ') : null;
  //   },
  //   button: false,
  // },
];

/* Кастомизация для определенных ролей */

// Водитель (Редактировать)
progresses.editDriver = [
  {
    title: 'Водительское удостоверение',
    name: 'driverLicense',
    completed: false,
    fields: [
      'driverLicense',
      'driverLicenseEndDate',
      'driverLicenseСategories',
    ],
    check: (values, form) => {
      return !!(
        !hasErrors(
          form.getFieldsError([
            'driverLicense',
            'driverLicenseEndDate',
            'driverLicenseСategories',
          ])
        ) &&
        values.driverLicense &&
        values.driverLicenseEndDate &&
        values.driverLicenseСategories
      );
    },
    getDescription: values => {
      if (
        values.driverLicense &&
        values.driverLicenseEndDate &&
        values.driverLicenseСategories
      ) {
        let val = values.driverLicense;
        let date =
          values.driverLicenseEndDate &&
          values.driverLicenseEndDate.format('DD.MM.YYYY');
        if (date) val += ` до ${date}`;
        return val;
      }
      return null;
    },
    button: false,
  },
  {
    title: 'Карты тахографа',
    name: 'tachographCards',
    completed: false,
    fields: [
      'tachographСards_skzi',
      'tachographСardsEndDate_skzi',
      'tachographСards_estr',
      'tachographСardsEndDate_estr',
    ],
    check: (values, form) => {
      return !!(
        (!hasErrors(
          form.getFieldsError([
            'tachographСards_skzi',
            'tachographСardsEndDate_skzi',
          ])
        ) &&
          values.tachographСards_skzi &&
          values.tachographСardsEndDate_skzi) ||
        (!hasErrors(
          form.getFieldsError([
            'tachographСards_estr',
            'tachographСardsEndDate_estr',
          ])
        ) &&
          values.tachographСards_estr &&
          values.tachographСardsEndDate_estr)
      );
    },
    getDescription: values => {
      let val = [];
      if (values.tachographСards_skzi && values.tachographСardsEndDate_skzi) {
        val.push('СКЗИ');
      }
      if (values.tachographСards_estr && values.tachographСardsEndDate_estr) {
        val.push('ЕСТР');
      }
      return val.length > 0 ? val.join(', ') : null;
    },
    button: false,
  },
  {
    title: 'Данные для АЦБПДП',
    name: 'dataForACBPDP',
    completed: false,
    fields: [
      'birthDate',
      'sex',
      'citizenship',
      'birthPlace',
      'identityDocument',
    ],
    check: (values, form) => {
      return !!(
        !hasErrors(
          form.getFieldsError([
            'birthDate',
            'sex',
            'citizenship',
            'birthPlace',
            'identityDocument',
          ])
        ) &&
        values.birthDate &&
        values.sex &&
        values.citizenship &&
        values.birthPlace &&
        values.identityDocument
      );
    },
    getDescription: (values, props) => {
      let val = [];
      let birthDate = values.birthDate && values.birthDate.format('DD.MM.YYYY');
      if (birthDate) val.push(`Д.р. ${birthDate}`);
      if (values.sex === '1') val.push('М');
      if (values.sex === '2') val.push('Ж');
      if (values.citizenship && props.citizenships) {
        let citizenshipId = +values.citizenship;
        let citizenship = props.citizenships.find(
          item => item.citizenshipId === citizenshipId
        );
        if (citizenship) {
          val.push(
            citizenship.citizenshipKey === 'RUS'
              ? 'РФ'
              : citizenship.citizenship
          );
        }
      }
      return val.length > 0 ? val.join(', ') : null;
    },
    button: false,
  },
  {
    title: 'Закрепленные ТС',
    name: 'fixedVehicles',
    completed: false,
    fields: ['fixedVehicles'],
    check: (values, form) => {
      return !!(
        !hasErrors(form.getFieldsError(['fixedVehicles'])) &&
        values.fixedVehicles
      );
    },
    getDescription: values => {
      return null;
    },
    button: false,
  },
  {
    title: 'Ограничения',
    name: 'restrictions',
    completed: false,
    fields: ['restrictions'],
    check: (values, form) => {
      return !!(
        !hasErrors(form.getFieldsError(['restrictions'])) && values.restrictions
      );
    },
    getDescription: values => {
      return null;
    },
    button: false,
  },
  {
    title: 'Дополнительная информация',
    name: 'otherInfo',
    completed: false,
    fields: [
      'glassesNeed',
      'foreignLanguages',
      'glassesNeed',
      'additionalInformation',
    ],
    check: (values, form) => {
      return (
        !hasErrors(form.getFieldsError(['glassesNeed'])) && values.glassesNeed
      );
    },
    getDescription: (values, props) => {
      let val = [];
      if (
        Array.isArray(values.foreignLanguages) &&
        values.foreignLanguages.length > 0 &&
        props.foreignLanguages
      ) {
        let foreignLanguages = props.foreignLanguages.filter(item =>
          values.foreignLanguages.some(lang => lang === item.foreignLanguageKey)
        );
        if (foreignLanguages.length > 0) {
          val.push(
            foreignLanguages.map(item => item.foreignLanguage).join(', ')
          );
        }
      }
      return val.length > 0 ? val.join(', ') : null;
    },
    button: false,
  },
  {
    title: 'Фото ВУ',
    name: 'photoDriverLicense',
    completed: false,
    fields: ['driverLicensePhotoBack', 'driverLicensePhotoFront'],
    check: (values, form) => {
      return (
        !hasErrors(
          form.getFieldsError([
            'driverLicensePhotoBack',
            'driverLicensePhotoFront',
          ])
        ) &&
        values.driverLicensePhotoBack &&
        values.driverLicensePhotoFront
      );
    },
    getDescription: values => {
      return null;
    },
    button: false,
  },
];

export default progresses;
